import { useEffect, useState } from "react";
import { api } from "../lib/api";
import AgentCard from "../components/AgentCard";
import { Search, ShieldCheck } from "lucide-react";

export default function Brokers() {
    const [items, setItems] = useState([]);
    const [city, setCity] = useState("");
    const [verifiedOnly, setVerifiedOnly] = useState(true);

    const load = async () => {
        const params = { role: "broker" };
        if (city) params.city = city;
        if (verifiedOnly) params.verified = true;
        const { data } = await api.get("/partners", { params });
        setItems(data || []);
    };

    useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

    return (
        <div className="min-h-screen bg-navy-900">
            <section className="bg-navy-950 border-b border-white/5">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
                    <div className="label-overline mb-3">Verified Network</div>
                    <h1 className="font-heading text-4xl lg:text-6xl font-bold text-white max-w-3xl">RERA-certified <span className="text-gold-500">brokers</span> across India</h1>
                    <p className="text-white/65 mt-4 max-w-2xl">All brokers undergo KYC, RERA verification, and ongoing trust scoring. Choose with confidence.</p>

                    <form onSubmit={(e) => { e.preventDefault(); load(); }} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-2xl">
                        <div className="relative flex-1">
                            <Search className="w-4 h-4 text-white/40 absolute left-3 top-1/2 -translate-y-1/2" />
                            <input value={city} onChange={(e) => setCity(e.target.value)} placeholder="Filter by city" className="w-full bg-navy-800 border border-white/10 rounded-md pl-9 pr-3 py-3 text-sm text-white" data-testid="brokers-city-input" />
                        </div>
                        <label className="flex items-center gap-2 text-sm text-white/70 px-3">
                            <input type="checkbox" checked={verifiedOnly} onChange={(e) => setVerifiedOnly(e.target.checked)} className="accent-gold-500" />
                            <ShieldCheck className="w-4 h-4 text-gold-500" /> Verified only
                        </label>
                        <button type="submit" className="px-6 py-3 rounded-md bg-gold-500 text-navy-900 font-semibold text-sm">Search</button>
                    </form>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
                {items.length === 0 ? (
                    <div className="text-center py-24 text-white/60">No brokers found</div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 stagger" data-testid="brokers-grid">
                        {items.map((a) => <AgentCard key={a.id} agent={a} />)}
                    </div>
                )}
            </section>
        </div>
    );
}
